export default "__VITE_ASSET__CjqKfN5V__"